<template>
  <div class="order-title-component">
    <div class="fl">
      <span>{{order.createDateTime}}</span>
      <span>{{order.studentName}}</span>
    </div>
    <div class="fr">订单号：{{order.serialNumber}}</div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.order-title-component {
  color: #333;
  font-size: 12px;
  background-color: #eee;
  height: 44px;
  line-height: 16px;
  padding: 15px 20px;
  div {
    span {
      margin-right: 5px;
    }
  }
}
</style>
